import React from "react"

const NotFoundModule = () => {
  return <div>404 Not Found</div>
}

export { NotFoundModule }
